document.addEventListener('DOMContentLoaded', function() {
    const sliders = document.querySelectorAll('.main_slider--wrapper'); // Select all slider wrappers

    sliders.forEach(slider => {
        const slidesContainer = slider.querySelector('.main_slider--inner');
        const slides = slidesContainer.querySelectorAll('.slide_item');
        const pagination = slider.querySelector('.up_pagination');
        let currentIndex = 0;

        // Function to show the current slide
        function showSlide(index) {
            const offset = -index * 100; // Each slide is 100% width
            slidesContainer.style.transform = `translateX(${offset}%)`;
            updatePagination();
        }

        // Function to update pagination buttons
        function updatePagination() {
            pagination.innerHTML = ''; // Clear existing buttons
            slides.forEach((_, i) => {
                const button = document.createElement('button');
                button.textContent = ''; // You can add text or an icon here if needed
                button.classList.toggle('active', i === currentIndex);
                button.addEventListener('click', () => {
                    currentIndex = i;
                    showSlide(currentIndex);
                });
                pagination.appendChild(button);
            });
        }

        // Function to handle swipe events
        function handleSwipe(startX, endX) {
            const threshold = 50; // Minimum distance to consider it a swipe
            if (startX - endX > threshold) {
                // Swipe left
                currentIndex = (currentIndex + 1) % slides.length; // Move to next slide
            } else if (endX - startX > threshold) {
                // Swipe right
                currentIndex = (currentIndex - 1 + slides.length) % slides.length; // Move to previous slide
            }
            showSlide(currentIndex);
        }

        // Touch event listeners for mobile
        let startX = 0;
        slidesContainer.addEventListener('touchstart', (e) => {
            startX = e.touches[0].clientX; // Get the starting touch position
        });

        slidesContainer.addEventListener('touchend', (e) => {
            const endX = e.changedTouches[0].clientX; // Get the ending touch position
            handleSwipe(startX, endX);
        });

        // Mouse event listeners for desktop
        let isMouseDown = false;
        let mouseStartX = 0;

        slidesContainer.addEventListener('mousedown', (e) => {
            isMouseDown = true;
            mouseStartX = e.clientX; // Get the starting mouse position
        });

        slidesContainer.addEventListener('mouseup', (e) => {
            if (isMouseDown) {
                isMouseDown = false;
                const endX = e.clientX; // Get the ending mouse position
                handleSwipe(mouseStartX, endX);
            }
        });

        slidesContainer.addEventListener('mouseleave', () => {
            isMouseDown = false; // Reset on mouse leave
        });

        // Initial setup
        showSlide(currentIndex);
    });
});